// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/voyages/voyage.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { EmptyRequest, EmptyResponse } from "../../../common/messages/messages";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "services.transportation.voyages";

export interface SubmitNorRequest {
  vesselImo: string;
  vesselName: string;
  shipVoyageNo: string;
  nor: Nor | undefined;
}

export interface GetVoyageByVesselImoRequest {
  vesselImo: string;
}

export interface GetAllVoyagesBetweenRequest {
  startTime: string | undefined;
  endTime: string | undefined;
}

export interface GetVoyageByIdRequest {
  id: string;
}

export interface VoyagesReponse {
  voyages: Voyage[];
}

export interface UpdateVoyageResponse {
  voyage: Voyage | undefined;
}

export interface VoyageResponse {
  data: Voyage | undefined;
  version: number;
}

export interface UpdateVoyageRequest {
  data: Voyage | undefined;
  expectedVersion: number;
}

export interface Voyage {
  id: string;
  vesselImo: string;
  vesselName: string;
  shipVoyageNo: string;
  charterer?: string | undefined;
  agentVoyageNo?:
    | string
    | undefined;
  /** optional string commitmentNo = 7 [deprecated = true]; */
  nors: Nor[];
  sofs: Sof[];
  billOfLadings: BillOfLading[];
  discharges: Discharge[];
  comments: Comment[];
  /** repeated actions.DatabaseAction actions = 14; */
  miscDocuments: MiscDocument[];
}

export interface Nor {
  timestamp: number;
  norType: string;
  portOrganisationId: string;
  /** repeated actions.DatabaseAction actions = 5; */
  fileId: string;
}

export interface SofEntry {
  key: string;
  timestamp: number;
}

export interface Sof {
  sofType: string;
  portOrganisationId: string;
  entries: SofEntry[];
  /** repeated actions.DatabaseAction actions = 5; */
  fileId: string;
}

export interface Sts {
  vesselImo: string;
  vesselName?: string | undefined;
  shipVoyageNo: string;
}

export interface ProductQuantity {
  product: string;
  grossWeight: number;
  density?: number | undefined;
}

export interface BillOfLading {
  no: string;
  shipperOrganisationId: string;
  consigneeOrganisationId: string;
  agentOrganisationId: string;
  notifyingOrganisationId?: string | undefined;
  date: number;
  loadingPortOrganisationId: string;
  products: ProductQuantity[];
  dischargingPortOrganisationId: string;
  fileId: string;
  revise: boolean;
  /**
   * This is not used
   *   stsLoading: Option[STS],
   * repeated actions.DatabaseAction actions = 14;
   */
  stsLoadings: Sts[];
}

export interface ProviderMeasurement {
  provider: string;
  providerId: string;
  product: string;
  weight: number;
  primary?: boolean | undefined;
}

export interface Discharge {
  fileId: string;
  portOrganisationId: string;
  consigneeOrganisationId?: string | undefined;
  date: number;
  sts: Sts | undefined;
  measurements: ProviderMeasurement[];
  /** repeated actions.DatabaseAction actions = 7; */
  billOfLadingNumbers: string[];
}

export interface Comment {
  incidentTimestamp: number;
  content: string;
  author: string;
  authorCommentTimestamp: number;
  authorTimezone: string;
  fileId?: string | undefined;
}

export interface MiscDocument {
  miscDocumentType: string;
  comment: string;
  fileId: string;
}

function createBaseSubmitNorRequest(): SubmitNorRequest {
  return { vesselImo: "", vesselName: "", shipVoyageNo: "", nor: undefined };
}

export const SubmitNorRequest: MessageFns<SubmitNorRequest> = {
  encode(message: SubmitNorRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.vesselName !== "") {
      writer.uint32(18).string(message.vesselName);
    }
    if (message.shipVoyageNo !== "") {
      writer.uint32(26).string(message.shipVoyageNo);
    }
    if (message.nor !== undefined) {
      Nor.encode(message.nor, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitNorRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitNorRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.shipVoyageNo = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.nor = Nor.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitNorRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      shipVoyageNo: isSet(object.shipVoyageNo)
        ? globalThis.String(object.shipVoyageNo)
        : isSet(object.ship_voyage_no)
        ? globalThis.String(object.ship_voyage_no)
        : "",
      nor: isSet(object.nor) ? Nor.fromJSON(object.nor) : undefined,
    };
  },

  toJSON(message: SubmitNorRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.shipVoyageNo !== "") {
      obj.shipVoyageNo = message.shipVoyageNo;
    }
    if (message.nor !== undefined) {
      obj.nor = Nor.toJSON(message.nor);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SubmitNorRequest>, I>>(base?: I): SubmitNorRequest {
    return SubmitNorRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SubmitNorRequest>, I>>(object: I): SubmitNorRequest {
    const message = createBaseSubmitNorRequest();
    message.vesselImo = object.vesselImo ?? "";
    message.vesselName = object.vesselName ?? "";
    message.shipVoyageNo = object.shipVoyageNo ?? "";
    message.nor = (object.nor !== undefined && object.nor !== null) ? Nor.fromPartial(object.nor) : undefined;
    return message;
  },
};

function createBaseGetVoyageByVesselImoRequest(): GetVoyageByVesselImoRequest {
  return { vesselImo: "" };
}

export const GetVoyageByVesselImoRequest: MessageFns<GetVoyageByVesselImoRequest> = {
  encode(message: GetVoyageByVesselImoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVoyageByVesselImoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetVoyageByVesselImoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetVoyageByVesselImoRequest {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
    };
  },

  toJSON(message: GetVoyageByVesselImoRequest): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetVoyageByVesselImoRequest>, I>>(base?: I): GetVoyageByVesselImoRequest {
    return GetVoyageByVesselImoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetVoyageByVesselImoRequest>, I>>(object: I): GetVoyageByVesselImoRequest {
    const message = createBaseGetVoyageByVesselImoRequest();
    message.vesselImo = object.vesselImo ?? "";
    return message;
  },
};

function createBaseGetAllVoyagesBetweenRequest(): GetAllVoyagesBetweenRequest {
  return { startTime: undefined, endTime: undefined };
}

export const GetAllVoyagesBetweenRequest: MessageFns<GetAllVoyagesBetweenRequest> = {
  encode(message: GetAllVoyagesBetweenRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTime !== undefined) {
      Timestamp.encode(toTimestamp(message.startTime), writer.uint32(10).fork()).join();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(toTimestamp(message.endTime), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllVoyagesBetweenRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllVoyagesBetweenRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllVoyagesBetweenRequest {
    return {
      startTime: isSet(object.startTime)
        ? globalThis.String(object.startTime)
        : isSet(object.start_time)
        ? globalThis.String(object.start_time)
        : undefined,
      endTime: isSet(object.endTime)
        ? globalThis.String(object.endTime)
        : isSet(object.end_time)
        ? globalThis.String(object.end_time)
        : undefined,
    };
  },

  toJSON(message: GetAllVoyagesBetweenRequest): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllVoyagesBetweenRequest>, I>>(base?: I): GetAllVoyagesBetweenRequest {
    return GetAllVoyagesBetweenRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllVoyagesBetweenRequest>, I>>(object: I): GetAllVoyagesBetweenRequest {
    const message = createBaseGetAllVoyagesBetweenRequest();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    return message;
  },
};

function createBaseGetVoyageByIdRequest(): GetVoyageByIdRequest {
  return { id: "" };
}

export const GetVoyageByIdRequest: MessageFns<GetVoyageByIdRequest> = {
  encode(message: GetVoyageByIdRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVoyageByIdRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetVoyageByIdRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetVoyageByIdRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: GetVoyageByIdRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetVoyageByIdRequest>, I>>(base?: I): GetVoyageByIdRequest {
    return GetVoyageByIdRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetVoyageByIdRequest>, I>>(object: I): GetVoyageByIdRequest {
    const message = createBaseGetVoyageByIdRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseVoyagesReponse(): VoyagesReponse {
  return { voyages: [] };
}

export const VoyagesReponse: MessageFns<VoyagesReponse> = {
  encode(message: VoyagesReponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.voyages) {
      Voyage.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoyagesReponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoyagesReponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voyages.push(Voyage.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoyagesReponse {
    return {
      voyages: globalThis.Array.isArray(object?.voyages) ? object.voyages.map((e: any) => Voyage.fromJSON(e)) : [],
    };
  },

  toJSON(message: VoyagesReponse): unknown {
    const obj: any = {};
    if (message.voyages?.length) {
      obj.voyages = message.voyages.map((e) => Voyage.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoyagesReponse>, I>>(base?: I): VoyagesReponse {
    return VoyagesReponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoyagesReponse>, I>>(object: I): VoyagesReponse {
    const message = createBaseVoyagesReponse();
    message.voyages = object.voyages?.map((e) => Voyage.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateVoyageResponse(): UpdateVoyageResponse {
  return { voyage: undefined };
}

export const UpdateVoyageResponse: MessageFns<UpdateVoyageResponse> = {
  encode(message: UpdateVoyageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voyage !== undefined) {
      Voyage.encode(message.voyage, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateVoyageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVoyageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voyage = Voyage.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateVoyageResponse {
    return { voyage: isSet(object.voyage) ? Voyage.fromJSON(object.voyage) : undefined };
  },

  toJSON(message: UpdateVoyageResponse): unknown {
    const obj: any = {};
    if (message.voyage !== undefined) {
      obj.voyage = Voyage.toJSON(message.voyage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVoyageResponse>, I>>(base?: I): UpdateVoyageResponse {
    return UpdateVoyageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVoyageResponse>, I>>(object: I): UpdateVoyageResponse {
    const message = createBaseUpdateVoyageResponse();
    message.voyage = (object.voyage !== undefined && object.voyage !== null)
      ? Voyage.fromPartial(object.voyage)
      : undefined;
    return message;
  },
};

function createBaseVoyageResponse(): VoyageResponse {
  return { data: undefined, version: 0 };
}

export const VoyageResponse: MessageFns<VoyageResponse> = {
  encode(message: VoyageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Voyage.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VoyageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoyageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Voyage.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoyageResponse {
    return {
      data: isSet(object.data) ? Voyage.fromJSON(object.data) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: VoyageResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = Voyage.toJSON(message.data);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoyageResponse>, I>>(base?: I): VoyageResponse {
    return VoyageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoyageResponse>, I>>(object: I): VoyageResponse {
    const message = createBaseVoyageResponse();
    message.data = (object.data !== undefined && object.data !== null) ? Voyage.fromPartial(object.data) : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseUpdateVoyageRequest(): UpdateVoyageRequest {
  return { data: undefined, expectedVersion: 0 };
}

export const UpdateVoyageRequest: MessageFns<UpdateVoyageRequest> = {
  encode(message: UpdateVoyageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      Voyage.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.expectedVersion !== 0) {
      writer.uint32(16).int64(message.expectedVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateVoyageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVoyageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = Voyage.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.expectedVersion = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateVoyageRequest {
    return {
      data: isSet(object.data) ? Voyage.fromJSON(object.data) : undefined,
      expectedVersion: isSet(object.expectedVersion)
        ? globalThis.Number(object.expectedVersion)
        : isSet(object.expected_version)
        ? globalThis.Number(object.expected_version)
        : 0,
    };
  },

  toJSON(message: UpdateVoyageRequest): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = Voyage.toJSON(message.data);
    }
    if (message.expectedVersion !== 0) {
      obj.expectedVersion = Math.round(message.expectedVersion);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVoyageRequest>, I>>(base?: I): UpdateVoyageRequest {
    return UpdateVoyageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVoyageRequest>, I>>(object: I): UpdateVoyageRequest {
    const message = createBaseUpdateVoyageRequest();
    message.data = (object.data !== undefined && object.data !== null) ? Voyage.fromPartial(object.data) : undefined;
    message.expectedVersion = object.expectedVersion ?? 0;
    return message;
  },
};

function createBaseVoyage(): Voyage {
  return {
    id: "",
    vesselImo: "",
    vesselName: "",
    shipVoyageNo: "",
    charterer: undefined,
    agentVoyageNo: undefined,
    nors: [],
    sofs: [],
    billOfLadings: [],
    discharges: [],
    comments: [],
    miscDocuments: [],
  };
}

export const Voyage: MessageFns<Voyage> = {
  encode(message: Voyage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.vesselImo !== "") {
      writer.uint32(18).string(message.vesselImo);
    }
    if (message.vesselName !== "") {
      writer.uint32(26).string(message.vesselName);
    }
    if (message.shipVoyageNo !== "") {
      writer.uint32(34).string(message.shipVoyageNo);
    }
    if (message.charterer !== undefined) {
      writer.uint32(42).string(message.charterer);
    }
    if (message.agentVoyageNo !== undefined) {
      writer.uint32(50).string(message.agentVoyageNo);
    }
    for (const v of message.nors) {
      Nor.encode(v!, writer.uint32(66).fork()).join();
    }
    for (const v of message.sofs) {
      Sof.encode(v!, writer.uint32(74).fork()).join();
    }
    for (const v of message.billOfLadings) {
      BillOfLading.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.discharges) {
      Discharge.encode(v!, writer.uint32(90).fork()).join();
    }
    for (const v of message.comments) {
      Comment.encode(v!, writer.uint32(98).fork()).join();
    }
    for (const v of message.miscDocuments) {
      MiscDocument.encode(v!, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Voyage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoyage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.shipVoyageNo = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.charterer = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.agentVoyageNo = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.nors.push(Nor.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.sofs.push(Sof.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.billOfLadings.push(BillOfLading.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.discharges.push(Discharge.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.comments.push(Comment.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.miscDocuments.push(MiscDocument.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Voyage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      shipVoyageNo: isSet(object.shipVoyageNo)
        ? globalThis.String(object.shipVoyageNo)
        : isSet(object.ship_voyage_no)
        ? globalThis.String(object.ship_voyage_no)
        : "",
      charterer: isSet(object.charterer) ? globalThis.String(object.charterer) : undefined,
      agentVoyageNo: isSet(object.agentVoyageNo)
        ? globalThis.String(object.agentVoyageNo)
        : isSet(object.agent_voyage_no)
        ? globalThis.String(object.agent_voyage_no)
        : undefined,
      nors: globalThis.Array.isArray(object?.nors)
        ? object.nors.map((e: any) => Nor.fromJSON(e))
        : [],
      sofs: globalThis.Array.isArray(object?.sofs)
        ? object.sofs.map((e: any) => Sof.fromJSON(e))
        : [],
      billOfLadings: globalThis.Array.isArray(object?.billOfLadings)
        ? object.billOfLadings.map((e: any) => BillOfLading.fromJSON(e))
        : globalThis.Array.isArray(object?.bill_of_ladings)
        ? object.bill_of_ladings.map((e: any) => BillOfLading.fromJSON(e))
        : [],
      discharges: globalThis.Array.isArray(object?.discharges)
        ? object.discharges.map((e: any) => Discharge.fromJSON(e))
        : [],
      comments: globalThis.Array.isArray(object?.comments) ? object.comments.map((e: any) => Comment.fromJSON(e)) : [],
      miscDocuments: globalThis.Array.isArray(object?.miscDocuments)
        ? object.miscDocuments.map((e: any) => MiscDocument.fromJSON(e))
        : globalThis.Array.isArray(object?.misc_documents)
        ? object.misc_documents.map((e: any) => MiscDocument.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Voyage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.shipVoyageNo !== "") {
      obj.shipVoyageNo = message.shipVoyageNo;
    }
    if (message.charterer !== undefined) {
      obj.charterer = message.charterer;
    }
    if (message.agentVoyageNo !== undefined) {
      obj.agentVoyageNo = message.agentVoyageNo;
    }
    if (message.nors?.length) {
      obj.nors = message.nors.map((e) => Nor.toJSON(e));
    }
    if (message.sofs?.length) {
      obj.sofs = message.sofs.map((e) => Sof.toJSON(e));
    }
    if (message.billOfLadings?.length) {
      obj.billOfLadings = message.billOfLadings.map((e) => BillOfLading.toJSON(e));
    }
    if (message.discharges?.length) {
      obj.discharges = message.discharges.map((e) => Discharge.toJSON(e));
    }
    if (message.comments?.length) {
      obj.comments = message.comments.map((e) => Comment.toJSON(e));
    }
    if (message.miscDocuments?.length) {
      obj.miscDocuments = message.miscDocuments.map((e) => MiscDocument.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Voyage>, I>>(base?: I): Voyage {
    return Voyage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Voyage>, I>>(object: I): Voyage {
    const message = createBaseVoyage();
    message.id = object.id ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.vesselName = object.vesselName ?? "";
    message.shipVoyageNo = object.shipVoyageNo ?? "";
    message.charterer = object.charterer ?? undefined;
    message.agentVoyageNo = object.agentVoyageNo ?? undefined;
    message.nors = object.nors?.map((e) => Nor.fromPartial(e)) || [];
    message.sofs = object.sofs?.map((e) => Sof.fromPartial(e)) || [];
    message.billOfLadings = object.billOfLadings?.map((e) => BillOfLading.fromPartial(e)) || [];
    message.discharges = object.discharges?.map((e) => Discharge.fromPartial(e)) || [];
    message.comments = object.comments?.map((e) => Comment.fromPartial(e)) || [];
    message.miscDocuments = object.miscDocuments?.map((e) => MiscDocument.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNor(): Nor {
  return { timestamp: 0, norType: "", portOrganisationId: "", fileId: "" };
}

export const Nor: MessageFns<Nor> = {
  encode(message: Nor, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== 0) {
      writer.uint32(8).int64(message.timestamp);
    }
    if (message.norType !== "") {
      writer.uint32(18).string(message.norType);
    }
    if (message.portOrganisationId !== "") {
      writer.uint32(26).string(message.portOrganisationId);
    }
    if (message.fileId !== "") {
      writer.uint32(34).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Nor {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNor();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.norType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portOrganisationId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Nor {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      norType: isSet(object.norType)
        ? globalThis.String(object.norType)
        : isSet(object.nor_type)
        ? globalThis.String(object.nor_type)
        : "",
      portOrganisationId: isSet(object.portOrganisationId)
        ? globalThis.String(object.portOrganisationId)
        : isSet(object.port_organisation_id)
        ? globalThis.String(object.port_organisation_id)
        : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: Nor): unknown {
    const obj: any = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.norType !== "") {
      obj.norType = message.norType;
    }
    if (message.portOrganisationId !== "") {
      obj.portOrganisationId = message.portOrganisationId;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Nor>, I>>(base?: I): Nor {
    return Nor.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Nor>, I>>(object: I): Nor {
    const message = createBaseNor();
    message.timestamp = object.timestamp ?? 0;
    message.norType = object.norType ?? "";
    message.portOrganisationId = object.portOrganisationId ?? "";
    message.fileId = object.fileId ?? "";
    return message;
  },
};

function createBaseSofEntry(): SofEntry {
  return { key: "", timestamp: 0 };
}

export const SofEntry: MessageFns<SofEntry> = {
  encode(message: SofEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.timestamp !== 0) {
      writer.uint32(16).int64(message.timestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SofEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSofEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SofEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
    };
  },

  toJSON(message: SofEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SofEntry>, I>>(base?: I): SofEntry {
    return SofEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SofEntry>, I>>(object: I): SofEntry {
    const message = createBaseSofEntry();
    message.key = object.key ?? "";
    message.timestamp = object.timestamp ?? 0;
    return message;
  },
};

function createBaseSof(): Sof {
  return { sofType: "", portOrganisationId: "", entries: [], fileId: "" };
}

export const Sof: MessageFns<Sof> = {
  encode(message: Sof, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sofType !== "") {
      writer.uint32(10).string(message.sofType);
    }
    if (message.portOrganisationId !== "") {
      writer.uint32(18).string(message.portOrganisationId);
    }
    for (const v of message.entries) {
      SofEntry.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.fileId !== "") {
      writer.uint32(34).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Sof {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSof();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sofType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portOrganisationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.entries.push(SofEntry.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sof {
    return {
      sofType: isSet(object.sofType)
        ? globalThis.String(object.sofType)
        : isSet(object.sof_type)
        ? globalThis.String(object.sof_type)
        : "",
      portOrganisationId: isSet(object.portOrganisationId)
        ? globalThis.String(object.portOrganisationId)
        : isSet(object.port_organisation_id)
        ? globalThis.String(object.port_organisation_id)
        : "",
      entries: globalThis.Array.isArray(object?.entries) ? object.entries.map((e: any) => SofEntry.fromJSON(e)) : [],
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: Sof): unknown {
    const obj: any = {};
    if (message.sofType !== "") {
      obj.sofType = message.sofType;
    }
    if (message.portOrganisationId !== "") {
      obj.portOrganisationId = message.portOrganisationId;
    }
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => SofEntry.toJSON(e));
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sof>, I>>(base?: I): Sof {
    return Sof.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sof>, I>>(object: I): Sof {
    const message = createBaseSof();
    message.sofType = object.sofType ?? "";
    message.portOrganisationId = object.portOrganisationId ?? "";
    message.entries = object.entries?.map((e) => SofEntry.fromPartial(e)) || [];
    message.fileId = object.fileId ?? "";
    return message;
  },
};

function createBaseSts(): Sts {
  return { vesselImo: "", vesselName: undefined, shipVoyageNo: "" };
}

export const Sts: MessageFns<Sts> = {
  encode(message: Sts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselImo !== "") {
      writer.uint32(10).string(message.vesselImo);
    }
    if (message.vesselName !== undefined) {
      writer.uint32(18).string(message.vesselName);
    }
    if (message.shipVoyageNo !== "") {
      writer.uint32(26).string(message.shipVoyageNo);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Sts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.shipVoyageNo = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Sts {
    return {
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : undefined,
      shipVoyageNo: isSet(object.shipVoyageNo)
        ? globalThis.String(object.shipVoyageNo)
        : isSet(object.ship_voyage_no)
        ? globalThis.String(object.ship_voyage_no)
        : "",
    };
  },

  toJSON(message: Sts): unknown {
    const obj: any = {};
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.vesselName !== undefined) {
      obj.vesselName = message.vesselName;
    }
    if (message.shipVoyageNo !== "") {
      obj.shipVoyageNo = message.shipVoyageNo;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Sts>, I>>(base?: I): Sts {
    return Sts.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Sts>, I>>(object: I): Sts {
    const message = createBaseSts();
    message.vesselImo = object.vesselImo ?? "";
    message.vesselName = object.vesselName ?? undefined;
    message.shipVoyageNo = object.shipVoyageNo ?? "";
    return message;
  },
};

function createBaseProductQuantity(): ProductQuantity {
  return { product: "", grossWeight: 0, density: undefined };
}

export const ProductQuantity: MessageFns<ProductQuantity> = {
  encode(message: ProductQuantity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.product !== "") {
      writer.uint32(10).string(message.product);
    }
    if (message.grossWeight !== 0) {
      writer.uint32(21).float(message.grossWeight);
    }
    if (message.density !== undefined) {
      writer.uint32(29).float(message.density);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProductQuantity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProductQuantity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.grossWeight = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.density = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProductQuantity {
    return {
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      grossWeight: isSet(object.grossWeight)
        ? globalThis.Number(object.grossWeight)
        : isSet(object.gross_weight)
        ? globalThis.Number(object.gross_weight)
        : 0,
      density: isSet(object.density) ? globalThis.Number(object.density) : undefined,
    };
  },

  toJSON(message: ProductQuantity): unknown {
    const obj: any = {};
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.grossWeight !== 0) {
      obj.grossWeight = message.grossWeight;
    }
    if (message.density !== undefined) {
      obj.density = message.density;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProductQuantity>, I>>(base?: I): ProductQuantity {
    return ProductQuantity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProductQuantity>, I>>(object: I): ProductQuantity {
    const message = createBaseProductQuantity();
    message.product = object.product ?? "";
    message.grossWeight = object.grossWeight ?? 0;
    message.density = object.density ?? undefined;
    return message;
  },
};

function createBaseBillOfLading(): BillOfLading {
  return {
    no: "",
    shipperOrganisationId: "",
    consigneeOrganisationId: "",
    agentOrganisationId: "",
    notifyingOrganisationId: undefined,
    date: 0,
    loadingPortOrganisationId: "",
    products: [],
    dischargingPortOrganisationId: "",
    fileId: "",
    revise: false,
    stsLoadings: [],
  };
}

export const BillOfLading: MessageFns<BillOfLading> = {
  encode(message: BillOfLading, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.no !== "") {
      writer.uint32(10).string(message.no);
    }
    if (message.shipperOrganisationId !== "") {
      writer.uint32(18).string(message.shipperOrganisationId);
    }
    if (message.consigneeOrganisationId !== "") {
      writer.uint32(26).string(message.consigneeOrganisationId);
    }
    if (message.agentOrganisationId !== "") {
      writer.uint32(34).string(message.agentOrganisationId);
    }
    if (message.notifyingOrganisationId !== undefined) {
      writer.uint32(42).string(message.notifyingOrganisationId);
    }
    if (message.date !== 0) {
      writer.uint32(48).int64(message.date);
    }
    if (message.loadingPortOrganisationId !== "") {
      writer.uint32(58).string(message.loadingPortOrganisationId);
    }
    for (const v of message.products) {
      ProductQuantity.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.dischargingPortOrganisationId !== "") {
      writer.uint32(74).string(message.dischargingPortOrganisationId);
    }
    if (message.fileId !== "") {
      writer.uint32(82).string(message.fileId);
    }
    if (message.revise !== false) {
      writer.uint32(88).bool(message.revise);
    }
    for (const v of message.stsLoadings) {
      Sts.encode(v!, writer.uint32(98).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BillOfLading {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBillOfLading();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.no = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.shipperOrganisationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.consigneeOrganisationId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.agentOrganisationId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.notifyingOrganisationId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.date = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.loadingPortOrganisationId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.products.push(ProductQuantity.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.dischargingPortOrganisationId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.revise = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.stsLoadings.push(Sts.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BillOfLading {
    return {
      no: isSet(object.no) ? globalThis.String(object.no) : "",
      shipperOrganisationId: isSet(object.shipperOrganisationId)
        ? globalThis.String(object.shipperOrganisationId)
        : isSet(object.shipper_organisation_id)
        ? globalThis.String(object.shipper_organisation_id)
        : "",
      consigneeOrganisationId: isSet(object.consigneeOrganisationId)
        ? globalThis.String(object.consigneeOrganisationId)
        : isSet(object.consignee_organisation_id)
        ? globalThis.String(object.consignee_organisation_id)
        : "",
      agentOrganisationId: isSet(object.agentOrganisationId)
        ? globalThis.String(object.agentOrganisationId)
        : isSet(object.agent_organisation_id)
        ? globalThis.String(object.agent_organisation_id)
        : "",
      notifyingOrganisationId: isSet(object.notifyingOrganisationId)
        ? globalThis.String(object.notifyingOrganisationId)
        : isSet(object.notifying_organisation_id)
        ? globalThis.String(object.notifying_organisation_id)
        : undefined,
      date: isSet(object.date) ? globalThis.Number(object.date) : 0,
      loadingPortOrganisationId: isSet(object.loadingPortOrganisationId)
        ? globalThis.String(object.loadingPortOrganisationId)
        : isSet(object.loading_portOrganisation_id)
        ? globalThis.String(object.loading_portOrganisation_id)
        : "",
      products: globalThis.Array.isArray(object?.products)
        ? object.products.map((e: any) => ProductQuantity.fromJSON(e))
        : [],
      dischargingPortOrganisationId: isSet(object.dischargingPortOrganisationId)
        ? globalThis.String(object.dischargingPortOrganisationId)
        : isSet(object.discharging_portOrganisation_id)
        ? globalThis.String(object.discharging_portOrganisation_id)
        : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      revise: isSet(object.revise) ? globalThis.Boolean(object.revise) : false,
      stsLoadings: globalThis.Array.isArray(object?.stsLoadings)
        ? object.stsLoadings.map((e: any) => Sts.fromJSON(e))
        : globalThis.Array.isArray(object?.sts_loadings)
        ? object.sts_loadings.map((e: any) => Sts.fromJSON(e))
        : [],
    };
  },

  toJSON(message: BillOfLading): unknown {
    const obj: any = {};
    if (message.no !== "") {
      obj.no = message.no;
    }
    if (message.shipperOrganisationId !== "") {
      obj.shipperOrganisationId = message.shipperOrganisationId;
    }
    if (message.consigneeOrganisationId !== "") {
      obj.consigneeOrganisationId = message.consigneeOrganisationId;
    }
    if (message.agentOrganisationId !== "") {
      obj.agentOrganisationId = message.agentOrganisationId;
    }
    if (message.notifyingOrganisationId !== undefined) {
      obj.notifyingOrganisationId = message.notifyingOrganisationId;
    }
    if (message.date !== 0) {
      obj.date = Math.round(message.date);
    }
    if (message.loadingPortOrganisationId !== "") {
      obj.loadingPortOrganisationId = message.loadingPortOrganisationId;
    }
    if (message.products?.length) {
      obj.products = message.products.map((e) => ProductQuantity.toJSON(e));
    }
    if (message.dischargingPortOrganisationId !== "") {
      obj.dischargingPortOrganisationId = message.dischargingPortOrganisationId;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.revise !== false) {
      obj.revise = message.revise;
    }
    if (message.stsLoadings?.length) {
      obj.stsLoadings = message.stsLoadings.map((e) => Sts.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BillOfLading>, I>>(base?: I): BillOfLading {
    return BillOfLading.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BillOfLading>, I>>(object: I): BillOfLading {
    const message = createBaseBillOfLading();
    message.no = object.no ?? "";
    message.shipperOrganisationId = object.shipperOrganisationId ?? "";
    message.consigneeOrganisationId = object.consigneeOrganisationId ?? "";
    message.agentOrganisationId = object.agentOrganisationId ?? "";
    message.notifyingOrganisationId = object.notifyingOrganisationId ?? undefined;
    message.date = object.date ?? 0;
    message.loadingPortOrganisationId = object.loadingPortOrganisationId ?? "";
    message.products = object.products?.map((e) => ProductQuantity.fromPartial(e)) || [];
    message.dischargingPortOrganisationId = object.dischargingPortOrganisationId ?? "";
    message.fileId = object.fileId ?? "";
    message.revise = object.revise ?? false;
    message.stsLoadings = object.stsLoadings?.map((e) => Sts.fromPartial(e)) || [];
    return message;
  },
};

function createBaseProviderMeasurement(): ProviderMeasurement {
  return { provider: "", providerId: "", product: "", weight: 0, primary: undefined };
}

export const ProviderMeasurement: MessageFns<ProviderMeasurement> = {
  encode(message: ProviderMeasurement, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== "") {
      writer.uint32(10).string(message.provider);
    }
    if (message.providerId !== "") {
      writer.uint32(18).string(message.providerId);
    }
    if (message.product !== "") {
      writer.uint32(26).string(message.product);
    }
    if (message.weight !== 0) {
      writer.uint32(33).double(message.weight);
    }
    if (message.primary !== undefined) {
      writer.uint32(40).bool(message.primary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProviderMeasurement {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProviderMeasurement();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.providerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.weight = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.primary = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProviderMeasurement {
    return {
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      providerId: isSet(object.providerId)
        ? globalThis.String(object.providerId)
        : isSet(object.provider_id)
        ? globalThis.String(object.provider_id)
        : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      weight: isSet(object.weight) ? globalThis.Number(object.weight) : 0,
      primary: isSet(object.primary) ? globalThis.Boolean(object.primary) : undefined,
    };
  },

  toJSON(message: ProviderMeasurement): unknown {
    const obj: any = {};
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.providerId !== "") {
      obj.providerId = message.providerId;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.weight !== 0) {
      obj.weight = message.weight;
    }
    if (message.primary !== undefined) {
      obj.primary = message.primary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProviderMeasurement>, I>>(base?: I): ProviderMeasurement {
    return ProviderMeasurement.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProviderMeasurement>, I>>(object: I): ProviderMeasurement {
    const message = createBaseProviderMeasurement();
    message.provider = object.provider ?? "";
    message.providerId = object.providerId ?? "";
    message.product = object.product ?? "";
    message.weight = object.weight ?? 0;
    message.primary = object.primary ?? undefined;
    return message;
  },
};

function createBaseDischarge(): Discharge {
  return {
    fileId: "",
    portOrganisationId: "",
    consigneeOrganisationId: undefined,
    date: 0,
    sts: undefined,
    measurements: [],
    billOfLadingNumbers: [],
  };
}

export const Discharge: MessageFns<Discharge> = {
  encode(message: Discharge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.portOrganisationId !== "") {
      writer.uint32(18).string(message.portOrganisationId);
    }
    if (message.consigneeOrganisationId !== undefined) {
      writer.uint32(26).string(message.consigneeOrganisationId);
    }
    if (message.date !== 0) {
      writer.uint32(32).int64(message.date);
    }
    if (message.sts !== undefined) {
      Sts.encode(message.sts, writer.uint32(42).fork()).join();
    }
    for (const v of message.measurements) {
      ProviderMeasurement.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.billOfLadingNumbers) {
      writer.uint32(66).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Discharge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDischarge();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portOrganisationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.consigneeOrganisationId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.date = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sts = Sts.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.measurements.push(ProviderMeasurement.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.billOfLadingNumbers.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Discharge {
    return {
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      portOrganisationId: isSet(object.portOrganisationId)
        ? globalThis.String(object.portOrganisationId)
        : isSet(object.port_organisation_id)
        ? globalThis.String(object.port_organisation_id)
        : "",
      consigneeOrganisationId: isSet(object.consigneeOrganisationId)
        ? globalThis.String(object.consigneeOrganisationId)
        : isSet(object.consignee_organisation_id)
        ? globalThis.String(object.consignee_organisation_id)
        : undefined,
      date: isSet(object.date) ? globalThis.Number(object.date) : 0,
      sts: isSet(object.sts) ? Sts.fromJSON(object.sts) : undefined,
      measurements: globalThis.Array.isArray(object?.measurements)
        ? object.measurements.map((e: any) => ProviderMeasurement.fromJSON(e))
        : [],
      billOfLadingNumbers: globalThis.Array.isArray(object?.billOfLadingNumbers)
        ? object.billOfLadingNumbers.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.bill_of_lading_numbers)
        ? object.bill_of_lading_numbers.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Discharge): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.portOrganisationId !== "") {
      obj.portOrganisationId = message.portOrganisationId;
    }
    if (message.consigneeOrganisationId !== undefined) {
      obj.consigneeOrganisationId = message.consigneeOrganisationId;
    }
    if (message.date !== 0) {
      obj.date = Math.round(message.date);
    }
    if (message.sts !== undefined) {
      obj.sts = Sts.toJSON(message.sts);
    }
    if (message.measurements?.length) {
      obj.measurements = message.measurements.map((e) => ProviderMeasurement.toJSON(e));
    }
    if (message.billOfLadingNumbers?.length) {
      obj.billOfLadingNumbers = message.billOfLadingNumbers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Discharge>, I>>(base?: I): Discharge {
    return Discharge.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Discharge>, I>>(object: I): Discharge {
    const message = createBaseDischarge();
    message.fileId = object.fileId ?? "";
    message.portOrganisationId = object.portOrganisationId ?? "";
    message.consigneeOrganisationId = object.consigneeOrganisationId ?? undefined;
    message.date = object.date ?? 0;
    message.sts = (object.sts !== undefined && object.sts !== null) ? Sts.fromPartial(object.sts) : undefined;
    message.measurements = object.measurements?.map((e) => ProviderMeasurement.fromPartial(e)) || [];
    message.billOfLadingNumbers = object.billOfLadingNumbers?.map((e) => e) || [];
    return message;
  },
};

function createBaseComment(): Comment {
  return {
    incidentTimestamp: 0,
    content: "",
    author: "",
    authorCommentTimestamp: 0,
    authorTimezone: "",
    fileId: undefined,
  };
}

export const Comment: MessageFns<Comment> = {
  encode(message: Comment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.incidentTimestamp !== 0) {
      writer.uint32(8).int64(message.incidentTimestamp);
    }
    if (message.content !== "") {
      writer.uint32(18).string(message.content);
    }
    if (message.author !== "") {
      writer.uint32(26).string(message.author);
    }
    if (message.authorCommentTimestamp !== 0) {
      writer.uint32(32).int64(message.authorCommentTimestamp);
    }
    if (message.authorTimezone !== "") {
      writer.uint32(42).string(message.authorTimezone);
    }
    if (message.fileId !== undefined) {
      writer.uint32(50).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Comment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.incidentTimestamp = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.author = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.authorCommentTimestamp = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.authorTimezone = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Comment {
    return {
      incidentTimestamp: isSet(object.incidentTimestamp)
        ? globalThis.Number(object.incidentTimestamp)
        : isSet(object.incident_timestamp)
        ? globalThis.Number(object.incident_timestamp)
        : 0,
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      author: isSet(object.author) ? globalThis.String(object.author) : "",
      authorCommentTimestamp: isSet(object.authorCommentTimestamp)
        ? globalThis.Number(object.authorCommentTimestamp)
        : isSet(object.author_comment_timestamp)
        ? globalThis.Number(object.author_comment_timestamp)
        : 0,
      authorTimezone: isSet(object.authorTimezone)
        ? globalThis.String(object.authorTimezone)
        : isSet(object.author_timezone)
        ? globalThis.String(object.author_timezone)
        : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : undefined,
    };
  },

  toJSON(message: Comment): unknown {
    const obj: any = {};
    if (message.incidentTimestamp !== 0) {
      obj.incidentTimestamp = Math.round(message.incidentTimestamp);
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.author !== "") {
      obj.author = message.author;
    }
    if (message.authorCommentTimestamp !== 0) {
      obj.authorCommentTimestamp = Math.round(message.authorCommentTimestamp);
    }
    if (message.authorTimezone !== "") {
      obj.authorTimezone = message.authorTimezone;
    }
    if (message.fileId !== undefined) {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Comment>, I>>(base?: I): Comment {
    return Comment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Comment>, I>>(object: I): Comment {
    const message = createBaseComment();
    message.incidentTimestamp = object.incidentTimestamp ?? 0;
    message.content = object.content ?? "";
    message.author = object.author ?? "";
    message.authorCommentTimestamp = object.authorCommentTimestamp ?? 0;
    message.authorTimezone = object.authorTimezone ?? "";
    message.fileId = object.fileId ?? undefined;
    return message;
  },
};

function createBaseMiscDocument(): MiscDocument {
  return { miscDocumentType: "", comment: "", fileId: "" };
}

export const MiscDocument: MessageFns<MiscDocument> = {
  encode(message: MiscDocument, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.miscDocumentType !== "") {
      writer.uint32(10).string(message.miscDocumentType);
    }
    if (message.comment !== "") {
      writer.uint32(18).string(message.comment);
    }
    if (message.fileId !== "") {
      writer.uint32(26).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MiscDocument {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMiscDocument();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.miscDocumentType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MiscDocument {
    return {
      miscDocumentType: isSet(object.miscDocumentType)
        ? globalThis.String(object.miscDocumentType)
        : isSet(object.misc_document_type)
        ? globalThis.String(object.misc_document_type)
        : "",
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: MiscDocument): unknown {
    const obj: any = {};
    if (message.miscDocumentType !== "") {
      obj.miscDocumentType = message.miscDocumentType;
    }
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MiscDocument>, I>>(base?: I): MiscDocument {
    return MiscDocument.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MiscDocument>, I>>(object: I): MiscDocument {
    const message = createBaseMiscDocument();
    message.miscDocumentType = object.miscDocumentType ?? "";
    message.comment = object.comment ?? "";
    message.fileId = object.fileId ?? "";
    return message;
  },
};

export interface VoyageService {
  updateNor(request: DeepPartial<SubmitNorRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
  getVoyageById(request: DeepPartial<GetVoyageByIdRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse>;
  addVoyage(request: DeepPartial<Voyage>, metadata?: grpc.Metadata): Promise<VoyageResponse>;
  updateVoyage(request: DeepPartial<UpdateVoyageRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse>;
  getPreviousVoyageById(request: DeepPartial<GetVoyageByIdRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse>;
  getNextVoyageById(request: DeepPartial<GetVoyageByIdRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse>;
  getVoyagesByImo(request: DeepPartial<GetVoyageByVesselImoRequest>, metadata?: grpc.Metadata): Promise<VoyagesReponse>;
  getAllVoyagesBetween(
    request: DeepPartial<GetAllVoyagesBetweenRequest>,
    metadata?: grpc.Metadata,
  ): Promise<VoyagesReponse>;
  getLatestVoyages(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<VoyagesReponse>;
}

export class VoyageServiceClientImpl implements VoyageService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.updateNor = this.updateNor.bind(this);
    this.getVoyageById = this.getVoyageById.bind(this);
    this.addVoyage = this.addVoyage.bind(this);
    this.updateVoyage = this.updateVoyage.bind(this);
    this.getPreviousVoyageById = this.getPreviousVoyageById.bind(this);
    this.getNextVoyageById = this.getNextVoyageById.bind(this);
    this.getVoyagesByImo = this.getVoyagesByImo.bind(this);
    this.getAllVoyagesBetween = this.getAllVoyagesBetween.bind(this);
    this.getLatestVoyages = this.getLatestVoyages.bind(this);
  }

  updateNor(request: DeepPartial<SubmitNorRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(VoyageServiceUpdateNorDesc, SubmitNorRequest.fromPartial(request), metadata);
  }

  getVoyageById(request: DeepPartial<GetVoyageByIdRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse> {
    return this.rpc.unary(VoyageServiceGetVoyageByIdDesc, GetVoyageByIdRequest.fromPartial(request), metadata);
  }

  addVoyage(request: DeepPartial<Voyage>, metadata?: grpc.Metadata): Promise<VoyageResponse> {
    return this.rpc.unary(VoyageServiceAddVoyageDesc, Voyage.fromPartial(request), metadata);
  }

  updateVoyage(request: DeepPartial<UpdateVoyageRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse> {
    return this.rpc.unary(VoyageServiceUpdateVoyageDesc, UpdateVoyageRequest.fromPartial(request), metadata);
  }

  getPreviousVoyageById(request: DeepPartial<GetVoyageByIdRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse> {
    return this.rpc.unary(VoyageServiceGetPreviousVoyageByIdDesc, GetVoyageByIdRequest.fromPartial(request), metadata);
  }

  getNextVoyageById(request: DeepPartial<GetVoyageByIdRequest>, metadata?: grpc.Metadata): Promise<VoyageResponse> {
    return this.rpc.unary(VoyageServiceGetNextVoyageByIdDesc, GetVoyageByIdRequest.fromPartial(request), metadata);
  }

  getVoyagesByImo(
    request: DeepPartial<GetVoyageByVesselImoRequest>,
    metadata?: grpc.Metadata,
  ): Promise<VoyagesReponse> {
    return this.rpc.unary(VoyageServiceGetVoyagesByImoDesc, GetVoyageByVesselImoRequest.fromPartial(request), metadata);
  }

  getAllVoyagesBetween(
    request: DeepPartial<GetAllVoyagesBetweenRequest>,
    metadata?: grpc.Metadata,
  ): Promise<VoyagesReponse> {
    return this.rpc.unary(
      VoyageServiceGetAllVoyagesBetweenDesc,
      GetAllVoyagesBetweenRequest.fromPartial(request),
      metadata,
    );
  }

  getLatestVoyages(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<VoyagesReponse> {
    return this.rpc.unary(VoyageServiceGetLatestVoyagesDesc, EmptyRequest.fromPartial(request), metadata);
  }
}

export const VoyageServiceDesc = { serviceName: "services.transportation.voyages.VoyageService" };

export const VoyageServiceUpdateNorDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateNor",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return SubmitNorRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceGetVoyageByIdDesc: UnaryMethodDefinitionish = {
  methodName: "GetVoyageById",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetVoyageByIdRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyageResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceAddVoyageDesc: UnaryMethodDefinitionish = {
  methodName: "AddVoyage",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return Voyage.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyageResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceUpdateVoyageDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateVoyage",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateVoyageRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyageResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceGetPreviousVoyageByIdDesc: UnaryMethodDefinitionish = {
  methodName: "GetPreviousVoyageById",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetVoyageByIdRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyageResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceGetNextVoyageByIdDesc: UnaryMethodDefinitionish = {
  methodName: "GetNextVoyageById",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetVoyageByIdRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyageResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceGetVoyagesByImoDesc: UnaryMethodDefinitionish = {
  methodName: "GetVoyagesByImo",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetVoyageByVesselImoRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyagesReponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceGetAllVoyagesBetweenDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllVoyagesBetween",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return GetAllVoyagesBetweenRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyagesReponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const VoyageServiceGetLatestVoyagesDesc: UnaryMethodDefinitionish = {
  methodName: "GetLatestVoyages",
  service: VoyageServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = VoyagesReponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
